var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yoyo-container mx-auto min-h-screen pb-[20px]" },
    [
      _c("navBar", { attrs: { title: _vm.$t("userInfo.title") } }),
      _c(
        "div",
        { staticClass: "bg-white mt-2 mx-4 rounded-xl" },
        [
          _c(
            "van-cell-group",
            { staticClass: "bg-transparent" },
            [
              _c("van-field", {
                staticClass: "name",
                attrs: {
                  label: _vm.$t("userInfo.name"),
                  placeholder: _vm.$t("userInfo.namePlaceholder"),
                },
                model: {
                  value: _vm.baseInfo.nickname,
                  callback: function ($$v) {
                    _vm.$set(_vm.baseInfo, "nickname", $$v)
                  },
                  expression: "baseInfo.nickname",
                },
              }),
              _c("van-field", {
                attrs: {
                  label: _vm.$t("userInfo.gender"),
                  readonly: "",
                  "is-link": "",
                  placeholder: _vm.$t("userInfo.genderPlaceholder"),
                },
                on: { "click-input": _vm.editGender },
                model: {
                  value: _vm.baseInfo.sexText,
                  callback: function ($$v) {
                    _vm.$set(_vm.baseInfo, "sexText", $$v)
                  },
                  expression: "baseInfo.sexText",
                },
              }),
              _c("van-field", {
                attrs: {
                  label: _vm.$t("userInfo.birthday"),
                  readonly: "",
                  "is-link": "",
                  placeholder: _vm.$t("userInfo.birthdayPlaceholder"),
                },
                on: { "click-input": _vm.editBirthday },
                model: {
                  value: _vm.baseInfo.birthday,
                  callback: function ($$v) {
                    _vm.$set(_vm.baseInfo, "birthday", $$v)
                  },
                  expression: "baseInfo.birthday",
                },
              }),
              _c("van-field", {
                attrs: {
                  label: _vm.$t("userInfo.country"),
                  placeholder: _vm.$t("userInfo.countryPlaceholder"),
                  readonly: "",
                  "is-link": "",
                },
                on: {
                  "click-input": function ($event) {
                    _vm.showCountryPopup = true
                  },
                },
                model: {
                  value: _vm.baseInfo.countryText,
                  callback: function ($$v) {
                    _vm.$set(_vm.baseInfo, "countryText", $$v)
                  },
                  expression: "baseInfo.countryText",
                },
              }),
              _c("van-field", {
                staticClass: "px-3",
                attrs: {
                  "label-width": "120px",
                  label: _vm.$t("userInfo.phone"),
                  placeholder: _vm.$t("userInfo.phonePlaceholder"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "flex-1 flex items-center justify-end",
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("van-field", {
                                  staticClass: "p-0",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "address.countryCodePlaceholder"
                                    ),
                                    readonly: "",
                                    "is-link": "",
                                  },
                                  on: {
                                    "click-input": function ($event) {
                                      _vm.showCountryCodePopup = true
                                    },
                                  },
                                  model: {
                                    value: _vm.baseInfo.countryCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.baseInfo, "countryCode", $$v)
                                    },
                                    expression: "baseInfo.countryCode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("van-field", {
                              staticClass: "p-0 w-44",
                              attrs: {
                                placeholder: _vm.$t(
                                  "userInfo.phonePlaceholder"
                                ),
                              },
                              model: {
                                value: _vm.baseInfo.mobile,
                                callback: function ($$v) {
                                  _vm.$set(_vm.baseInfo, "mobile", $$v)
                                },
                                expression: "baseInfo.mobile",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.baseInfo.mobile,
                  callback: function ($$v) {
                    _vm.$set(_vm.baseInfo, "mobile", $$v)
                  },
                  expression: "baseInfo.mobile",
                },
              }),
            ],
            1
          ),
          _vm.isEdit
            ? _c(
                "van-button",
                {
                  staticClass: "mx-16 w-[calc(100%-8rem)] my-3",
                  attrs: { type: "primary", round: "", color: "#ff7a00" },
                  on: { click: _vm.updateBaseInfo },
                },
                [_vm._v(" " + _vm._s(_vm.$t("userInfo.updateUserInfo")) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bg-white mt-2 mx-4 rounded-xl" },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                attrs: {
                  label: _vm.$t("userInfo.changePassword"),
                  "label-width": "140px",
                  readonly: "",
                  "is-link": "",
                },
                on: {
                  "click-input": function ($event) {
                    _vm.dialogVisible = true
                  },
                },
              }),
              _c("van-field", {
                attrs: {
                  label: _vm.$t("userInfo.email"),
                  placeholder: _vm.$t("userInfo.emailPlaceholder"),
                },
                model: {
                  value: _vm.baseInfo.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.baseInfo, "email", $$v)
                  },
                  expression: "baseInfo.email",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bg-white mt-2 mx-4 rounded-xl" },
        [
          _c("van-cell", {
            attrs: {
              title: _vm.$t("userInfo.address"),
              border: false,
              "is-link": "",
            },
            scopedSlots: _vm._u([
              {
                key: "right-icon",
                fn: function () {
                  return [
                    _c(
                      "van-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          round: "",
                          color: "#ff7a00",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.goToAddAddress.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " + " + _vm._s(_vm.$t("userInfo.addAddress")) + " "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "px-4 pb-4" },
            _vm._l(_vm.addresses, function (address, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "bg-gray-50 rounded-lg p-3 mb-3 flex justify-between items-start mb-2",
                  on: {
                    click: function ($event) {
                      return _vm.goToAddAddress(address)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "flex-1" }, [
                    _c("div", { staticClass: "font-medium text-gray-800" }, [
                      _vm._v(
                        _vm._s(address.name) + " | " + _vm._s(address.mobile)
                      ),
                    ]),
                    _c("div", { staticClass: "text-sm text-gray-600 mt-1" }, [
                      _vm._v(
                        _vm._s(address.country) +
                          " " +
                          _vm._s(address.city) +
                          " " +
                          _vm._s(address.detailAddress)
                      ),
                    ]),
                  ]),
                  address.defaultStatus
                    ? _c(
                        "van-button",
                        {
                          staticClass: "w-10",
                          attrs: {
                            type: "warning",
                            size: "mini",
                            round: "",
                            color: "#ff7a00",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("userInfo.default")) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showGenderPopup,
            callback: function ($$v) {
              _vm.showGenderPopup = $$v
            },
            expression: "showGenderPopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.genderOptions },
            on: {
              confirm: _vm.onGenderConfirm,
              cancel: function ($event) {
                _vm.showGenderPopup = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showCountryPopup,
            callback: function ($$v) {
              _vm.showCountryPopup = $$v
            },
            expression: "showCountryPopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.countryOptions },
            on: {
              confirm: _vm.onCountryConfirm,
              cancel: function ($event) {
                _vm.showCountryPopup = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showDatePopup,
            callback: function ($$v) {
              _vm.showDatePopup = $$v
            },
            expression: "showDatePopup",
          },
        },
        [
          _c("van-datetime-picker", {
            attrs: { type: "date", "min-date": _vm.minDate },
            on: {
              confirm: _vm.onDateConfirm,
              cancel: function ($event) {
                _vm.showDatePopup = false
              },
            },
            model: {
              value: _vm.selectedDate,
              callback: function ($$v) {
                _vm.selectedDate = $$v
              },
              expression: "selectedDate",
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showCountryCodePopup,
            callback: function ($$v) {
              _vm.showCountryCodePopup = $$v
            },
            expression: "showCountryCodePopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.countryCodeList },
            on: {
              confirm: _vm.onCountryCodeConfirm,
              cancel: function ($event) {
                _vm.showCountryCodePopup = false
              },
            },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function (slotProps) {
                  return [
                    _c("div", { staticClass: "flex items-center text-sm" }, [
                      _c("img", {
                        staticClass: "w-5 h-auto",
                        attrs: { src: slotProps.icon, alt: "" },
                      }),
                      _c("span", { staticClass: "ml-3" }, [
                        _vm._v(_vm._s(slotProps.text)),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "CommonDialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("userInfo.changePassword"),
            buttons: [
              {
                text: _vm.$t("common.confirm"),
                type: "primary",
                action: "submit",
              },
            ],
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            "button-click": _vm.handleButtonClick,
            close: _vm.handleClose,
          },
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "mb-4" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password",
                  },
                ],
                staticClass:
                  "w-full h-12 px-4 border border-gray-200 rounded-lg text-sm",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("userInfo.passwordPlaceholder"),
                },
                domProps: { value: _vm.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.password = $event.target.value
                  },
                },
              }),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }